module.exports = __webpack_public_path__ + "img/work_the_way_youre_used_to.554e910e.png";